


const API_CHECK_CODE_REQUEST = 'API_CHECK_CODE_REQUEST';
const RESET_CODE_REQUEST = 'RESET_CODE_REQUEST';
const API_CHECK_CODE_SUCCESS = 'API_CHECK_CODE_SUCCESS';
const API_CHECK_CODE_FAILURE = 'API_CHECK_CODE_FAILURE';





export const checkCodeRequest = payload => ({
  type: API_CHECK_CODE_REQUEST,
  payload: payload
});

export const checkCodeSuccess = payload => ({
  type: API_CHECK_CODE_SUCCESS,
  payload,
});

export const checkCodeFailure = payload => ({
  type: API_CHECK_CODE_FAILURE,
  payload,
});

export const resetCodeRequest = payload => ({
  type: RESET_CODE_REQUEST,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  codeMessage:null
};

export function checkCodeReducer(state = initialState, action) {
 
  switch (action.type) {
    case API_CHECK_CODE_REQUEST:
    
    return {
      ...state,
      fetching: true,
      error:null
    };
    case RESET_CODE_REQUEST:
    
    return {
      ...state,
      codeMessage: null
    };
     
    case API_CHECK_CODE_SUCCESS:
    
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        codeMessage: action.payload
      };
    case API_CHECK_CODE_FAILURE:
    
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/checkProjectCode.js